export const KEYWORD_OVERVIEW = /* GraphQL */ `
  query KeywordOverview {
    keywordOverview {
      totalKeywords
      avgMonthlyVolume
      topExposureCount
      activeTrackingCount
    }
  }
`;

export const KEYWORD_STATS = /* GraphQL */ `
  query KeywordStats($count: Int) {
    keywordStats(count: $count) {
      keywordId
      keyword
      monthlySearchVolume
      monthlySearchVolumePc
      monthlySearchVolumeMobile
      yearlySearchVolume
      weeklySearchVolume
      dailySearchVolume
      competitionIndex
      productionCount {
        total
        yearly
        monthly
        weekly
      }
      sections
      categories
    }
  }
`;

export const KEYWORD_DETAIL = /* GraphQL */ `
  query KeywordDetail($keyword: String!) {
    keywordDetail(keyword: $keyword) {
      keywordId
      keyword
      monthlySearchVolume
      monthlySearchVolumePc
      monthlySearchVolumeMobile
      yearlySearchVolume
      weeklySearchVolume
      dailySearchVolume
      competitionIndex
      productionCount {
        total
        yearly
        monthly
        weekly
      }
      sections
      categories
      trend {
        keyword
        points {
          period
          ratio
        }
        volume
        yoy
        relatedKeywords
      }
      related {
        keywordId
        keyword
        monthlySearchVolume
        competitionIndex
        productionCount {
          total
          yearly
          monthly
          weekly
        }
        sections
        categories
      }
    }
  }
`;

export const KEYWORD_TRENDS = /* GraphQL */ `
  query KeywordTrends($keywords: [String!]!) {
    keywordTrends(keywords: $keywords) {
      keyword
      points {
        period
        ratio
      }
      volume
      yoy
      relatedKeywords
    }
  }
`;

export const KEYWORDS_LIST = /* GraphQL */ `
  query Keywords(
    $filter: KeywordFilterInput
    $sort: SortInput
    $pagination: PaginationInput
  ) {
    keywords(filter: $filter, sort: $sort, pagination: $pagination) {
      items {
        core {
          id
          keyword
          keywordHash
          datalabHashKey
        }
        volume {
          monthlyPcQcCnt
          monthlyMobileQcCnt
          monthlyTotalQcCnt
          monthlyAvePcClkCnt
          monthlyAveMobileClkCnt
          monthlyAvePcCtr
          monthlyAveMobileCtr
        }
        competition {
          compIdx
          plAvgDepth
        }
        bids {
          minBidPc
          minBidMobile
          medianBidPc
          medianBidMobile
        }
        management {
          tier
          priority
          isActive
        }
        lifecycle {
          createdAt
          updatedAt
          lastSeenAt
          firstDiscoveredAt
        }
      }
      pageInfo {
        total
        offset
        limit
        hasMore
        nextCursor
      }
    }
  }
`;

export const KEYWORD_MONTHLY_STATS = /* GraphQL */ `
  query KeywordMonthlyStats(
    $months: Int
    $sort: SortInput
    $pagination: PaginationInput
  ) {
    keywordMonthlyStats(months: $months, sort: $sort, pagination: $pagination) {
      items {
        keywordId
        keyword
        statMonth
        monthlyPcQcCnt
        monthlyMobileQcCnt
        monthlyTotalQcCnt
        monthlyAvePcClkCnt
        monthlyAveMobileClkCnt
        compIdx
        collectedAt
      }
      pageInfo {
        total
        offset
        limit
        hasMore
        nextCursor
      }
    }
  }
`;

export const KEYWORD_BIDS = /* GraphQL */ `
  query KeywordBids(
    $filter: KeywordBidFilterInput
    $sort: SortInput
    $pagination: PaginationInput
  ) {
    keywordBids(filter: $filter, sort: $sort, pagination: $pagination) {
      items {
        id
        bidWeek
        keywordId
        keyword
        device
        exposureMinimumBid
        medianBid
        averagePositionBid
        positionBids {
          position
          bid
        }
        performanceEstimates {
          bid
          clicks
          cost
          impressions
          ctr
        }
        level
        collectedAt
      }
      pageInfo {
        total
        offset
        limit
        hasMore
        nextCursor
      }
    }
  }
`;

export const KEYWORD_RANKINGS = /* GraphQL */ `
  query KeywordRankings(
    $filter: KeywordRankingFilterInput
    $sort: SortInput
    $pagination: PaginationInput
  ) {
    keywordRankings(filter: $filter, sort: $sort, pagination: $pagination) {
      items {
        contentId
        keywordId
        keyword
        bestRank
        avgRank
        latestRank
        rankTrend
        appearances
        lastRankedAt
      }
      pageInfo {
        total
        offset
        limit
        hasMore
        nextCursor
      }
    }
  }
`;

export const KEYWORD_TREND_ROWS = /* GraphQL */ `
  query KeywordTrendRows(
    $filter: KeywordTrendRowFilterInput
    $sort: SortInput
    $pagination: PaginationInput
  ) {
    keywordTrendRows(filter: $filter, sort: $sort, pagination: $pagination) {
      items {
        keywordId
        keyword
        timeUnit
        periodStart
        periodEnd
        pcQcCnt
        mobileQcCnt
        ratio
        yoyTrend
        trendDirection
      }
      pageInfo {
        total
        offset
        limit
        hasMore
        nextCursor
      }
    }
  }
`;
